export type MaskTypes = keyof typeof MASKS;

export const MASKS = {
  phone: '(##) #####-####',
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  cep: '#####-###',
  date: '##/##/####',
  time: '##:##',
  datetime: '##/##/#### ##:##',
};
